import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home/Home.vue'
import ArticleList from './views/ArticleList/ArticleList.vue'
import Article from './views/ArticleList/Article/Article.vue'
import Clinical from './views/Clinical/Clinical.vue'
import ClinincalList from './views/Clinical/ClinincalList/ClinincalList.vue'
import radiate from './views/radiate/radiate.vue'
import radiateList from './views/radiate/radiateList/radiateList.vue'
import qc from './views/qc/qc.vue'
import qcList from './views/qc/qcList/qcList.vue'
import SectionIntroduction from './views/DepartmentIntroduction/SectionIntroduction/SectionIntroduction.vue'
import SectionIntroductionDetail from './views/DepartmentIntroduction/SectionIntroductionDetail/SectionIntroductionDetail.vue'
import ExperteList from './views/DepartmentIntroduction/ExperteList/ExperteList.vue'
import ExperteDetails from './views/DepartmentIntroduction/ExperteList/ExperteDetails/ExperteDetails.vue'
import TeachingVideo from './views/TeachingActivity/TeachingVideo/TeachingVideo.vue'
import Videos from './views/TeachingActivity/TeachingVideo/Videos/Videos.vue'
import Activity from './views/TeachingActivity/Activity/Activity.vue'
import CaseDetails from './views/TeachingActivity/Activity/CaseDetails/CaseDetails.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/home',
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: {
        title: '湖北省核医学诊疗专科联盟',
      },
    },
    {
      path: '/articlelist',
      name: 'ArticleList',
      component: ArticleList,
      meta: {
        title: '学术动态',
      },
    },
    {
      path: '/articlelist/article',
      name: 'Article',
      component: Article,
      meta: {
        title: '学术动态详情',
      },
    },
    {
      path: '/clinical',
      name: 'Clinical',
      component: Clinical,
      meta: {
        title: '指南规范',
      },
    },
    {
      path: '/clinincalList',
      name: 'ClinincalList',
      component: ClinincalList,
      meta: {
        title: '指南规范',
      },
    },
    {
      path: '/radiate',
      name: 'radiate',
      component: radiate,
      meta: {
        title: '辐射安全',
      },
    },
    {
      path: '/radiateList',
      name: 'radiateList',
      component: radiateList,
      meta: {
        title: '辐射安全详情',
      },
    },
    {
      path: '/qc',
      name: 'qc',
      component: qc,
      meta: {
        title: '质量控制',
      },
    },
    {
      path: '/qcList',
      name: 'qcList',
      component: qcList,
      meta: {
        title: '质量控制详情',
      },
    },
    {
      path: '/sectionintroduction',
      name: 'SectionIntroduction',
      component: SectionIntroduction,
      meta: {
        title: '成员单位',
      },
    },
    {
      path: '/SectionIntroductionDetail',
      name: 'SectionIntroductionDetail',
      component:SectionIntroductionDetail,
      meta: {
        title: '成员单位',
      },
    },
    {
      path: '/expertelist',
      name: 'ExperteList',
      component: ExperteList,
      meta: {
        title: '专家介绍',
      },
    },
    {
      path: '/expertelist/expertedetails',
      name: 'ExperteDetails',
      component: ExperteDetails,
      meta: {
        title: '专家详情',
      },
    },
    {
      path: '/teachingvideo',
      name: 'TeachingVideo',
      component: TeachingVideo,
      meta: {
        title: '学术讲座',
      },
    },
    {
      path: '/teachingvideo/videos',
      name: 'Videos',
      component: Videos,
      meta: {
        title: '学术讲座',
      },
    },
    {
      path: '/activity',
      name: 'Activity',
      component: Activity,
      meta: {
        title: '病例分析',
      },
    },
    {
      path: '/activity/casedetails',
      name: 'CaseDetails',
      component: CaseDetails,
      meta: {
        title: '病例分析详情',
      },
    },
  ]
})
